<template>
  <div class="echarts-contain">
    <div :id="id" class="o-echarts"></div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "columnCharts",
  props: {
    columnData: Array,
    xAxis: Array,
    unit: String,
    dimensions: Array,
    colors: Array,
    showName: Boolean,
  },
  data() {
    return {
      id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
      echartObj: null,
      unitName: "人",
      option: {
        legend: {
          show: false,
          bottom: 6,
          itemWidth: 7,
          itemHeight: 7,
          selectedMode: false,
          textStyle: {
            color: "#999",
            fontSize: 10
          }
        },

        xAxis: {
          type: "category",
          nameTextStyle: {
            color: "#ff0000",
            fontSize: 10
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            // rotate: 30,
            show: true,
            marginRight: 50,
            textStyle: {
              color: "#4A4A4A",
              fontSize: 10
            },
            formatter: function(value) {
              return value.length > 6 ? value.slice(0, 6) + "..." : value;
            }
          },
          axisLine: {
            lineStyle: {
              color: "#E9E9E9"
            }
          }
        },
        yAxis: {
          name: ` 单位（${this.unit ? this.unit : "人"}）`,
          nameGap: "16",
          splitNumber: 6,
          nameTextStyle: {
            color: "#999"
          },
          type: "value",
          axisLine: {
            // y轴
            show: false
          },
          // 网格样式
          splitLine: {
            show: true,
            lineStyle: {
              color: "#E9E9E9",
              width: 0.5,
              type: "solid"
            }
          },
          // interval: 5,
          axisTick: {
            // y轴刻度线
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#999"
            },
            formatter: value => {
              if (value.toString().length < 5) {
                return value;
              } else if (value.toString().length < 9) {
                return value / 10000 + "(万)";
              } else if (value.toString().length < 13) {
                return value / 100000000 + "(亿)";
              }
            }
          }
        },
        dataZoom: [
          // 调整柱状图X轴间隔
          {
            type: "inside",
            start: 0,
            end: 24,
            zoomLock: true
          }
        ],
        grid: {
          top: 50,
          right: 24,
          left: 60
        },
        axisTick: {
          // y轴刻度线
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: this.color === "green" ? "#333" : "#ffffff"
          }
        },
        barGap: "300%",
        series: [
          {
            type: "bar",
            barWidth: 8,
            barGap: "80%"
          },
          // {
          //   type: "bar",
          //   barWidth: 8,
          //   barGap: "80%"
          // },
          // {
          //   type: "bar",
          //   barWidth: 8,
          //   barGap: "80%",
          //   barCategoryGap: "200%"
          // }
        ]
      }
    };
  },
  mounted() {
    this.unitName = this.unit ? this.unit : "人";
    this.echartObj = echarts.init(document.getElementById(this.id));
    this.echartObj.setOption(this.setSeriesData(), true);
  },
  methods: {
    getXaxisData() {
      // 填入横轴数据
      return this.xAxis;
    },
    setSeriesData() {
      this.setOptions(
        "dataset",
        (() => {
          return {
            dimensions: this.dimensions,
            source: this.columnData
          };
        })()
      );
      this.setOptions(
        "dataZoom",
        (() => {
          const maxLen = Math.ceil(this.columnData.length / 3) * 3;
          const endPersent = Math.floor(250 / maxLen);
          return {
            type: "inside",
            start: 0,
            end: endPersent,
            zoomLock: true
          };
        })()
      );
      this.setOptions(
        "color",
        (() => {
          return this.colors;
        })()
      );
      let that = this;
      this.setOptions(
        "tooltip",
        (() => {
          return {
            trigger: "axis",
            position: function(point, params, dom) {
              return [point[0], "10%"];
            },
            confine: true,
            axisPointer: {
              type: "shadow",
              shadowStyle: {
                width: 20
              }
            },
            extraCssText:
              "position: absolute;padding: 4px 6px;line-height: 17px;font-size: 12px;color: #fff; border-radius: 0;",
            backgroundColor: "#333",
            formatter: function(params) {
              if (that.showName) {
                return (
                  '<div class="chart_tip">' +
                  params[0].axisValueLabel +
                  "<br /><span style='color: rgba(255, 255, 255, .75);'>" +
                  params[0].seriesName +
                  ":" +
                  params[0].value[params[0].seriesName] +
                  // "</span><br /><span style='color: rgba(255, 255, 255, .75);'>" +
                  // params[1].seriesName +
                  // ":" +
                  // params[1].value[params[1].seriesName] +
                  // "</span><br /><span style='color: rgba(255, 255, 255, .75);'>" +
                  // params[2].seriesName +
                  // ":" +
                  // params[2].value[params[2].seriesName] +
                  "</span></div>"
                );
              } else {
                return (
                  '<div class="tips">' +
                  params[0].seriesName +
                  ":" +
                  params[0].value[params[0].seriesName] +
                  "<br />" +
                  // params[1].seriesName +
                  // ":" +
                  // params[1].value[params[1].seriesName] +
                  // "<br />" +
                  // params[2].seriesName +
                  // ":" +
                  // params[2].value[params[2].seriesName] +
                  "</div>"
                );
              }
            }
          };
        })()
      );
      return this.option;
    },

    setOptions(objKey, objVal) {
      if (
        this.option[objKey] &&
        typeof this.option[objKey] === "object" &&
        !Array.isArray(this.option[objKey])
      ) {
        this.option[objKey] = Object.assign(this.option[objKey], objVal);
      } else {
        this.option[objKey] = objVal;
      }
      this.$set(this.option, objKey, this.option[objKey]);
    }
  }
};
</script>

<style lang="less" scoped>
.echarts-contain {
  width: 100%;
  height: 90%;
  .o-echarts {
    width: 100%;
    height: 100%;
  }
  .o-echarts:last-child {
    z-index: 99 !important;
  }
}
.chart_tip span {
  opacity: 0.75;
  // background-color: #ff0000 !important;
}
</style>
